import { customers } from './customers';

export const v1 = {
  customers,
};
